export enum LocalStorageKeys {
  feedFreezeDebug = "feed-freeze-debug_v1",
  onboarding = "onboarding_v2",
  userSelectRecents = "user_select_recents_v1",
  notificationsFiltersAndSort = "notifications-filters-and-sort_v1",
  earningsFiltersAndSort = "earnings-filters-and-sort_v1",
  discoverFiltersAndSort = "discover-filters-and-sort_v1",
  mainFeedActiveTab = "main-feed-active-tab_v1",
  mainFeedActiveSurface = "main-feed-active-surface_v1",
  mainFeedTemporarySurface = "main-feed-temporary-surface_v1",
  searchFeedActiveTab = "search-feed-active-tab_v1",
  commentStates = "comment-states_v1",
  selectedListId = "selected-list-id_v1",
  testnetBanner = "testnet-banner_v1",
  feedMeta = "feed-meta_v1",
  floatingPostButton = "floating-post-button_v2",
  filtersProfile = "filters-profile_v1",
  filtersProfileMedia = "filters-profile-media_v1",
  tokenPostLaunchOverviewTimeFilter = "token-post-launch-overview-time-filter_v1",
  hasSkippedPWAInstall = "has-skipped-pwa-install_v1",
  pendingPassword = "pending-password_v1",
  sidebarWidgetPreset = "sidebarWidgetPreset_v1",
  sidebarWidgetTimePeriod = "sidebarWidgetTimePeriod_v1",
  notificationPageFilters = "notification-page-filters_v1",
  notificationsActiveView = "notifications-active-view_v1",
  invitesBanner = "invites-banner_v1",
  collectionsViewMode = "collections-view-mode_v1",
  collectionsFilter = "collection-filter_v1",
  collectionsVisibility = "collection-visibility_v1",
  subscriptionTierHealth = "subscription-tier-health_v1",
  editorMode = "editor-v2-mode_v1",
  draftShowAutosaves = "draft-show-autosaves_v1",
  postViews = "post-views_v1",
  videoAutoplayEnabled = "video-autoplay-enabled_v1",
}
